<template>
  <el-drawer
    title="热话绑定"
    :visible.sync="drawer"
    :direction="direction"
    :with-header="false"
    :before-close="handleClose"
  >
    <div class="page_view">
      <el-table
        ref="tableArr"
        v-loading="isLoading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="getRowClass"
      >
        <template v-for="item in items">
          <el-table-column
            :key="item.name"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          ></el-table-column>
        </template>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          class="operate"
          width="160"
        >
          <template scope="scope">
            <div>
              <el-button @click="onHandle(scope.row,false)" size="mini" type="danger" v-if="scope.row.selected">删除</el-button>
              <el-button @click="onHandle(scope.row,true)" size="mini" type="success" v-else>選擇</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,15]"
        :page-size="paginate"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagecount"
      ></el-pagination>
    </div>
  </el-drawer>
</template>
<script>
export default {
  name: "hots-edit",
  data() {
    return {
      drawer: false,
      direction: "rtl",
      tableData: [],
      paginate:10,
      pagecount: 1,
      currentPage:1,
      language: 'tw',
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "name" }
      ],
      selected:[],
    };
  },
  methods: {
    show(values, language) {
      this.drawer = true;
      this.language = language;
      this.selected = values||[];
      console.log("seclected:",this.selected);
      this.getData(this.language,this.currentPage,this.paginate);
    },
    getData(language='tw',page=1,size=10) {
      var self = this;
      this.$http.get("/admin/tags",{language:language, page:page, size:size}).then(res => {
        console.log("res:", res);
        let {data,total}  = res.data;
        self.pagecount = total;

        data.forEach((element)=>{
          element.selected = self.getSelected(element);
        })
        console.log("table:",data);
        self.tableData = data;
      });
    },

    getSelected(value)
    {
      for(var i=0;i<this.selected.length;i++)
      {
        var item = this.selected[i];
        if(item.tag && parseInt(item.tag.id)===parseInt(value.id))
        {
          return true;
        }
      }
      return false;
    },
    onHandle(value,selected)
    {
      value.selected = selected;
      this.$emit("selected",value);
      //this.drawer = false;
    },
    handleClose() {
      this.drawer = false;
    },
    handleCurrentChange(value)
    {
      console.log("value",value);
      this.currentPage = value
        this.getData(this.language,this.currentPage,this.paginate);
    },
    handleSizeChange(size)
    {
        this.paginate = size;
        this.getData(this.language,this.currentPage,this.paginate);
    },
  }
};
</script>